module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("czeC4"))).then(() => parcelRequire('ljYL6'));